export const siteInfo = {
  brand: '爆瓜爆料',
  slogan: '实时直击第一现场，不错过任何一个大瓜',
  intro:
    '爆瓜爆料是一个聚合全网娱乐快讯的爆料资讯站。我们把散落在各处的瓜聚合、分级、快讯化，用吃瓜热度值帮你快速定位值得看的热点，再用第一现场时间线把来龙去脉讲清楚。',
  email: 'tips@baogua.example.com',
  sloganList: ['热点不隔夜', '来源必核实', '时间线复盘'],
};

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '影视爆料', to: '/category/yingshi' },
  { label: '综艺现场', to: '/category/zongyi' },
  { label: '明星日常', to: '/category/mingxing' },
  { label: '网红直播', to: '/category/wanghong' },
  { label: '常见问题', to: '/faq' },
  { label: '关于我们', to: '/about' },
];

export const tickerItems = [
  '《长安夜行》开机三天紧急换角，剧组深夜发声明',
  '《我们的舞台》第三季录制现场临时改赛制',
  '巡演两站突然取消，工作室回应声带需休养',
  '双顶流机场同框被拍，双方团队均未回应',
  '《雾港》大结局提前泄露，平台连夜排查',
  '直播间突然中断，人气主播宣布停播整改',
  '音乐节压轴换人，主办方称因天气调整顺序',
  '《归途列车》补拍传闻四起，导演回应正常补镜',
];

export const stats = [
  { value: '24h', label: '快讯更新频率', icon: 'ri-time-line' },
  { value: '186', label: '本周追踪事件', icon: 'ri-radar-line' },
  { value: '72万', label: '月度吃瓜人次', icon: 'ri-group-line' },
  { value: '9.2', label: '用户信息可信度评分', icon: 'ri-shield-check-line' },
];

export const editorPrinciples = [
  {
    icon: 'ri-search-eye-line',
    title: '来源必核实',
    desc: '任何爆料在发布前至少经过两条独立信息源比对，无法确认的内容一律标注待核实。',
  },
  {
    icon: 'ri-route-line',
    title: '时间线复盘',
    desc: '把事件拆成可追溯的节点，让你看到每个进展是什么时候、由谁透露的。',
  },
  {
    icon: 'ri-arrow-right-up-line',
    title: '持续更新',
    desc: '同一个瓜只放一个页面，后续进展就地追加，避免标题党式的重复信息。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '不站队不炒作',
    desc: '不替任何一方下结论，也不为了流量放大未经证实的情节。',
  },
];

export const testimonials = [
  {
    name: '阿禾',
    tag: '追剧党',
    text: '最省事的一点是同一个瓜只有一个页面，后续进展直接补上，不用在十几个标题党里翻来翻去。',
  },
  {
    name: '老K',
    tag: '综艺迷',
    text: '时间线做得清楚，我一般先看时间线再看正文，三分钟就搞清楚到底发生了什么。',
  },
  {
    name: '小满',
    tag: '吃瓜新手',
    text: '热度值挺有用，直接告诉我今天最值得看的是哪几条，不用自己猜。',
  },
];